import { Empty, Skeleton, Table } from 'antd';
import type { ExtractedFieldRow } from '../utils/extracted-fields.util';

interface Props {
  rows: ExtractedFieldRow[];
  loading: boolean;
}

const ExtractedFieldsTable = ({ rows, loading }: Props) => {
  if (loading) return <Skeleton active paragraph={{ rows: 4 }} />;
  if (rows.length === 0) return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No extracted fields" />;
  return (
    <Table
      size="small"
      pagination={false}
      rowKey="path"
      dataSource={rows}
      columns={[
        { title: 'Field', dataIndex: 'path', width: '45%' },
        { title: 'Value', dataIndex: 'value' },
      ]}
    />
  );
};

export default ExtractedFieldsTable;
